/**
 * Format a duration as mm:ss, with an optional preformatted override.
 *
 * @param seconds - Duration in seconds.
 * @param formatted - Optional preformatted string to use instead.
 * @returns Formatted duration string.
 *
 * @example
 * formatDurationValue(90) // "1:30"
 */
export function formatDurationValue(
  seconds?: number | null,
  formatted?: string | null
): string {
  if (formatted) {
    return formatted;
  }
  if (!seconds) {
    return '-';
  }
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Format transcript timestamps as mm:ss.cc (centiseconds).
 *
 * @param seconds - Seconds since start of call.
 * @returns Transcript timestamp string.
 *
 * @example
 * formatTranscriptTimestamp(61.23) // "1:01.23"
 */
export function formatTranscriptTimestamp(seconds: number): string {
  const safeSeconds = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
  const minutes = Math.floor(safeSeconds / 60);
  const wholeSeconds = Math.floor(safeSeconds % 60);
  const decimals = Math.round((safeSeconds - Math.floor(safeSeconds)) * 100);
  const secondsText = String(wholeSeconds).padStart(2, '0');
  const decimalText = String(decimals).padStart(2, '0');
  return `${minutes}:${secondsText}.${decimalText}`;
}
